import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ObjectInDialogService {
  private _close$ = new Subject<any>();

  close(item?: any): void {
    this._close$.next(item);
  }

  get close$(): Observable<any> {
    return this._close$.asObservable();
  }
}
